export const API_URL = '/events/';
export const AZURE_API_URL = '/azure/';
export const BATCH_SIZE = 10;
export const events = pageContext.events;
export const streamSources = pageContext.streamSources;
export const eventAccessTypes = pageContext.accessTypes;
export const channels = pageContext.channels;

export const USER_TYPE = Object.freeze({
    AspNetUser: 0,
    AzureAdUser: 1,
    Anonymous: 2
});

export const VIEWING_STATE = Object.freeze({
    scheduled: 0,
    live: 1,
    ended: 2,
    unpublished: 3,
    published: 4,
    notpublished: 5,
    endedredirect: 6
});

export const VIEWING_STATE_STRINGS = Object.freeze({
    scheduled: 'Scheduled',
    live: 'Live',
    ended: 'Ended',
    unpublished: 'Unpublished',
    published: 'Published',
    notpublished: 'Not Published',
    endedredirect: 'Redirecting'
});

export const USER_INTERACTION_TYPE = Object.freeze({
    none: 0,
    announcements: 1,
    qna: 2,
    chat: 3,
    qna_standalone: 4,
    all: 5
});
export const USER_INTERACTION_TYPE_STRINGS = [
    'None',
    'Announcements only',
    'User questions and announcements',
    'Live comments and announcements',
    'User questions only',
    'Comments, questions and announcements'
];

export const POST_EVENT_BEHAVIOR = Object.freeze({
    none: 0,
    vod: 1,
    redirect: 2
});
export const LIVE_STREAM_START_STATUS = Object.freeze({
    none: 0,
    starting: 1,
    stopping: 2
});
export const POST_EVENT_BEHAVIOR_STRINGS = ['None', 'VoD', 'Redirect'];
export const POST_EVENT_BEHAVIOR_FRIENDLY_NAMES = [
    'Show "Event has ended"-message',
    'Show event recording',
    'Redirect to link'
];

export const STREAMING_PROTOCOL = Object.freeze({
    rtmp: 0,
    srt: 1
});
export const STREAMING_PROTOCOL_STRINGS = ['RTMP', 'SRT'];

// Formatted as: Tuesday, February 9, 2016 10:00 AM.
// We must specify the format when using the Date constructor as
// specified in https://github.com/moment/moment/issues/1407.
export const DATE_FORMAT = 'dddd, MMMM D, YYYY HH:mm a';

// Manages event and permission state
export const FILTER = Object.freeze({
    active: 0,
    past: 1,
    permissions: 2
});
